import React from 'react';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../../atoms/Atoms';
import Avatar from './shared-components/Avatar';

function User() {
  const user = useRecoilValue(userAtom);
  if (user) {
    return (
      <div className="flex flex-row-reverse md:flex-row text-xs justify-end">
        <div className="mx-2 text-white">
          <div className="font-light text-white tracking-tight truncate">
            {user.completeName}
          </div>
          <div className="font-light text-white tracking-tight truncate">{user.email}</div>
        </div>
        <Avatar />
      </div>
    );
  }
  return null;
}

export default User;
